import { DecimalPipe, NgFor, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { SchadenUebersicht } from '@gsm/entities';
import { MomentModule } from 'ngx-moment';

@Component({
  selector: 'gsm-form-nachbringen-aktinformation',
  templateUrl: './form-nachbringen-aktinformation.component.html',
  styleUrls: ['./form-nachbringen-aktinformation.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    NgFor,
    DecimalPipe,
    MomentModule
  ]
})
export class FormNachbringenAktinformationComponent {
  displayedColumns: string[] = [
    'bezeichnung',
    'wert'
  ];
  @Input() aktInfo: SchadenUebersicht;

  schadenaktInfos = [
    {
      bezeichnung: 'Betreuernummer',
      wert:        '234234'
    },
    {
      bezeichnung: 'Meldedatum',
      wert:        '234222'
    }
  ];

  getCheckListItemStatus(checkListItemStatus) {
    switch (checkListItemStatus) {
      case 'N':
        return 'NICHT VORHANDEN';
      case 'H':
        return 'HINFÄLLIG';
      default:
        return '';
    }
  }

  convertToCheckListStatusText(checkListStatus) {
    switch (checkListStatus) {
      case 'K':
        return 'Kein GSM Schaden';
      case 'P':
        return 'Prüfbar/Vollständig';
      case 'N':
        return 'Nicht prüfbar/Unvollständig';
      case 'T':
        return 'Teilweise prüfbar/Unvollständig';
      default:
        return 'Unbekannt';
    }
  }

  checkForStatusN(): boolean {
    const hasStatusN = this.aktInfo.checklistItemList.find(element => element.status === 'N');
    return !!hasStatusN;
  }
}
